import { useCallback } from "react";
import useFeature from "hooks/useFeature";
import useRightSidebar from "hooks/useRightSidebar";
import { useModalContext } from "common/contexts";
function useAssetPanel() {
  var _a, _b;
  const isRightSidebarEnabled = useFeature("asset_right_sidebar");
  const { openSidebar, closeSidebar, content } = useRightSidebar();
  const { setModal, setEntity, entity } = useModalContext();
  const selectedAssetId = isRightSidebarEnabled ? (_a = content == null ? void 0 : content.props) == null ? void 0 : _a.assetId : (_b = entity == null ? void 0 : entity.asset) == null ? void 0 : _b.id;
  const openAssetDetails = useCallback(
    (asset) => {
      if (isRightSidebarEnabled) {
        openSidebar({
          id: `asset-${asset.id}`,
          title: "Asset Details",
          componentKey: "AssetSidebarContent",
          props: { assetId: asset.id }
        });
      } else {
        setEntity({ asset });
        setModal("ASSET-DETAILS");
      }
    },
    [isRightSidebarEnabled, openSidebar, setModal, setEntity]
  );
  const closeAssetDetails = useCallback(() => {
    if (isRightSidebarEnabled) {
      closeSidebar();
    } else {
      setModal(null);
      setEntity(null);
    }
  }, [isRightSidebarEnabled, closeSidebar, setModal, setEntity]);
  return {
    selectedAssetId,
    openAssetDetails,
    closeAssetDetails
  };
}
export default useAssetPanel;
